export default __webpack_public_path__ + "static/media/Background_00167.36389ae6.png";